import {
  BlockchainNetwork,
  ConstantsHelper,
  getRenecRPCEndpointUrl,
  getRenecWSRPCEndpointUrl,
  getSolanaRPCEndpointUrl,
  getSolanaWSRPCEndpointUrl,
} from "@renec-foundation/relend-adapter"
import { Connection } from "@solana/web3.js"

export const renecConnection = new Connection(getRenecRPCEndpointUrl(), {
  wsEndpoint: getRenecWSRPCEndpointUrl(),
})

export const solanaConnection = new Connection(getSolanaRPCEndpointUrl(), {
  wsEndpoint: getSolanaWSRPCEndpointUrl(),
})

export const getConnection = (network: BlockchainNetwork) =>
  ConstantsHelper.isRenecChain(network) ? renecConnection : solanaConnection
